/*//////////////////////*/
/* Imports
/*/ /////////////////////*/
import { useEffect, useMemo, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { getContentReducer } from "../../store/content/content.selector";
import { getProgrammeReducer } from "../../store/programme/programme.selector";
import { parameters } from "../../utils/virtualbuilding.utils";
import { getProjectsReducer } from "../../store/projects/projects.selector";
import { getScale, getSearchOption } from "../../utils/helpers.utils";
import { ArrowRight } from "../../icons/ArrowRight.icon";
import { SurfaceIcon } from "../../icons/Surface.icon";
import { BatimentIcon } from "../../icons/Batiment.icon";
import { EtageIcon } from "../../icons/Etage.icon";
import { OptionsIcon } from "../../icons/Options.icon";
import { OrientationIcon } from "../../icons/Orientation.icon";
import { TypeIcon } from "../../icons/Type.icon";
import { PrixIcon } from "../../icons/Prix.icon";
import { EyeIcon } from "../../icons/Eye.icon";
import Select from "react-select";
import Loader from "../Loader/Loader.component";
import "./SearchForm.styles.scss";


const customStyles = {
  option: (provided, state) => ({
    ...provided,
    backgroundColor : "white",
    color: 'black',
  }),
  // control: () => ({
  //   width: 200,
  // }),
  menuList: () => ({
    border: "solid 2px black",
    borderRadius : "8px",
    overflow: "hidden",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}


const SearchForm = () => {

  // Properties
  const { projectID, scaleID } = useParams();
  const [searchParams] = useSearchParams();
  const projectsReducer = useSelector(getProjectsReducer);
  const scale = useMemo(
    () => getScale(projectsReducer, projectID, scaleID),
    [projectID, scaleID, projectsReducer]
  );
  const navigate = useNavigate();
  const { register, handleSubmit, control } = useForm();
  const [filters, setFilters] = useState(null)
  const [loading, setLoading] = useState(true);
  const {
    texts: {
      searchButton,
    },
  } = useSelector(getContentReducer);

  // Functions
  const getIconFromLot = (icon) => {
    
    switch (icon) {
      case "PrixIcon":
        return <PrixIcon />
      case "SurfaceIcon":
        return <SurfaceIcon />
      case "TypeIcon":
        return <TypeIcon />
      case "EtageIcon":
        return <EtageIcon />
      case "BatimentIcon":
        return <BatimentIcon />
      case "OrientationIcon":
        return <OrientationIcon />
      case "OptionsIcon":
        return <OptionsIcon />
      default :
        return <SurfaceIcon />
    }
  }

  const onSubmit = async (fields) => {

    setLoading(true);
    const infos = [];
    for (let parameter of Object.keys(fields)) {
      if (fields[parameter]) {
        infos.push({
          name: parameter,
          value: Array.isArray(fields[parameter])
            ? fields[parameter].join(",")
            : fields[parameter],
        });
      }
    }

    /* Navigation avec paramètres */
    navigate(
      `/project/${projectID}/scale/${scaleID}/search/results?${infos
        .map((info) => `${info.name}=${info.value}`)
        .join("&")}`
    );
  }


  // Effects
  useEffect(() => {
    if (scale && scale?.lotsFilters?.data?.attributes?.url) {
      fetch(`https://strapi-tzjc.onrender.com${scale?.lotsFilters?.data?.attributes?.url}`)
      .then(response => response.text())
      .then(csv => {
        const legendsCSV = csv.split("\r\n")[0].split(",")
        const parsedCSV = csv.split("\r\n").slice(1).map(v => v.split(","))

        const legendsDatas = []

        parsedCSV.map(legend => {
          const legendDatas = {}

          legendsCSV.map((v, i) => {
            legendDatas[v] = i !== 2 ? legend[i] : legend[i].split("|").map(option => { return {value : option, label : option}})
          })

          legendsDatas.push(legendDatas)
        })

        setFilters(legendsDatas)
      })
    }
  }, [scale])

  // Render
  return (
    filters &&
    <form className="searchForm relative" onSubmit={handleSubmit(onSubmit)}>
      {filters.filter(f => f.search === 'true').map(filter => 
        <div className = "formLine">
          <div className = "lineColor"></div>

          <span className = "searchIcon">{getIconFromLot(filter.icon)}</span>
          

          <label>{filter.nom}</label>
          
          {filter.type === "range" &&
            <div className="inputParent | flex gap-x-4 gap-y-0">
              <span className = "nbInputs">
                <div className = "nbInput"></div>
                <div className = "nbInput"></div>
              </span>
              <input
                {...register(`min${filter.nom}`)}
                className="mb-0"
                type="number"
                placeholder="Min."
                defaultValue={searchParams.get(`min${filter.nom}`)}
              />
              <input
                {...register(`max${filter.nom}`)}
                className="mb-0"
                type="number"
                placeholder="Max."
                defaultValue={searchParams.get(`max${filter.nom}`)}
              />
            </div>
          }

          {filter.type === "multiselect" &&
            <div className="inputParent selectParent selector">
              <Controller
                control={control}
                name={filter.nom}
                defaultValue={searchParams.get(filter.nom)}
                render={({ field: { onChange, value } }) => (
                  <Select
                    noOptionsMessage={() => "Aucun étage disponible"}
                    placeholder= {`${filter.options[0].label}...`}
                    value={filter.options.find((c) => c.value === value)}
                    onChange={(val) => onChange(val.map((c) => c.value))}
                    options={filter.options}
                    isMulti
                    defaultValue={getSearchOption(
                      searchParams.get(filter.nom),
                      filter.options
                    )}
                    styles = {customStyles}
                  />
                )}
              />
            </div>
        }    
      </div>)}

      <button type="submit" className="py-4">
        {searchButton}
      </button>

    </form>
  )
}


export default SearchForm;
